"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgbaInterpolation = rgbaInterpolation;
var _linearInterpolation = require("./linearInterpolation");
/*
	domain: Array[Number]
	colors: Array[[r,g,b,a]]

	returns: Number => [r,g,b,a]
*/
function rgbaInterpolation(domain, colors) {
  const channelInters = [0, 1, 2, 3].map(channelIdx => (0, _linearInterpolation.linearInterpolation)(domain, colors.map(c => c[channelIdx])));
  return function (x) {
    return channelInters.map(inter => inter(x));
  };
}